const priorityWeight = { high: 0, medium: 1, low: 2 };

export const buildCompactAIInsightView = (report = {}) => {
  const metrics = Array.isArray(report.metrics) ? report.metrics.slice(0, 4) : [];
  const priorities = Array.isArray(report.insights)
    ? [...report.insights]
        .sort((a, b) => (priorityWeight[a?.priority] ?? 3) - (priorityWeight[b?.priority] ?? 3))
        .slice(0, 3)
    : [];

  const detailGroups = [
    report.diagnostics,
    report.risks,
    report.opportunities,
    report.forecastSignals,
    report.dataQuality,
    report.nextSteps,
  ];

  return {
    metrics,
    priorities,
    hasDetails: detailGroups.some((items) => Array.isArray(items) && items.length > 0),
  };
};

export default buildCompactAIInsightView;
